module.exports = __webpack_public_path__ + "img/line2.9810273b.svg";